module.exports = "/complete_profile_new-2cccf7f39f2f8521205f802ed6d001f1.svg";